var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('a',{staticClass:"spacing back",attrs:{"data-ga":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('b-icon-chevron-left'),_vm._v("上一步 ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }